export const QUIZ_META_REQUEST = 'QUIZ_META_REQUEST'
export const QUIZ_META_SUCCESS = 'QUIZ_META_SUCCESS'
export const QUIZ_META_FAILURE = 'QUIZ_META_FAILURE'
